import { ValidatorsProps } from '@ui/src';

export enum CurrencyForWritingOffFee {
  IN_TRANSACTION_CURRENCY = 'in Transaction currency',
  IN_FEE_CURRENCY = 'in Fee currency',
}

export interface FeeListItem {
  id?: string;
  name: string;
  value: string;
  type?: CurrencyForWritingOffFee;
}

export interface FeeType {
  title?: string;
  id?: string;
  list: FeeListItem[];
  type?: string;
  subType?: string;
}

export enum WorkMethod {
  TRANSACTION = 'Transaction Fee',
  REGULAR = 'Regular Fee',
  MANUAL = 'Manual Fee',
}

export interface FeesValidators {
  createFeeSchema: ValidatorsProps;
  updateFeeSchema: ValidatorsProps;
}

export enum FeeTypeEnum {
  MANUAL = 'MANUAL',
  REGULAR = 'REGULAR',
  TRANSACTION = 'TRANSACTION',
  INTERNAL = 'INTERNAL',
}

export enum FeeTransactionTypeEnum {
  OUTGOING = 'OUTGOING',
  INCOMING = 'INCOMING',
  INTERNAL = 'INTERNAL',
}

export enum FeeAmountTypeEnum {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
}

export enum FeeSubTypeEnum {
  INACTIVITY = 'INACTIVITY',
  HIGH_BALANCE = 'HIGH_BALANCE',
  REGULAR = 'REGULAR',
}

export enum FeePeriodEnum {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  BIMONTHLY = 'BIMONTHLY',
  QUARTER = 'QUARTER',
  HALF_YEAR = 'HALF_YEAR',
  YEAR = 'YEAR',
}

export interface FeeItem {
  name: string;
  feeType: string;
  feeAmountType: string;
  feeTransactionType: string;
  regularFeeSubType: string;
  regularFeePeriod: string;
  regularHighBalanceAmount: number;
  feePercentMinAmount: number;
  feePercentMaxAmount: number;
  paymentType: string;
  feeTargetAccountNumber: string;
  regularInactivityMonthsAmount?: number;
  id: string;
  createdAt: string;
}

export interface FeeItemFormValues {
  feeType?: string;
  regularFeeSubType?: string;
  regularFeePeriod?: string;
  name: string;
  regularHighBalanceAmount?: string | number;
  feeTargetAccountNumber?: string;
  paymentType?: string;
  feeTransactionType?: string;
  regularInactivityMonthsAmount?: string | number;
}

export interface FeesListItem {
  type: string;
  subType?: string;
  list?: FeeItem[];
}
